const requireConsent = "eu"; // none | eu | all
const consentValidityDays = 365;

export { requireConsent, consentValidityDays };
